import React from "react";
import Typography from "@mui/material/Typography";
import "./TitleBar.css";

const titleBar = () => (
  <div className="container-text-bar">
    <img
      className="brand-mark"
      src={`${process.env.PUBLIC_URL}/favicon.svg`}
      alt=""
      aria-hidden="true"
    />
    <div className="brand-copy">
      <Typography component="div" className="app-title">
        Jaya Sukses Pratama
      </Typography>
      <Typography component="div" className="app-description">
        Packaging Machinery
      </Typography>
    </div>
  </div>
);

export default titleBar;
